import { Typography } from "@mui/material";

const UnderConstruction = () => {
  return <Typography variant="h1">This Page is under construction</Typography>;
};

export default UnderConstruction;
